import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import { addToWishList, removeWishListItem } from '../../Redux/features/WishList/WishlistSlice';
import { formatSlug } from '../../Utils/Helper';
import { useLocation } from 'react-router-dom';

const ProductDetailsRelatedProducts = () => {
    const { apiURL, apiHeaderJson, currency, currencyValue } = useContext(ConfigContext);
    const wishList = useSelector(state => state.Wishlist)
    const [productData, setProductData] = useState([]);
    const [product_category_id, setproduct_category_id] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const path = useLocation();
    const product_id = path.pathname.split('=')[1];
    const [data, setData] = useState([])

    const GetProductDetails = async () => {
        try {
            const response = await axios.get(`${apiURL}Products/GetProductDetails`, {
                params: { product_id: product_id },
                headers: apiHeaderJson
            });
            console.log(response, "===>")
            if (response.data.success) {
                setproduct_category_id(response.data.data[0].product_category_id);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const GetProducts = async () => {
        try {

            const response = await axios.get(`${apiURL}Home/GetRelatedProducts`, { params: { product_id: product_id, product_category_id: product_category_id }, headers: apiHeaderJson });
            if (response.data.success) {
                setProductData(response.data.data);
            }
        } catch (error) {
            console.error("Error while fetching GetProducts", error)
        }

    };

    const handleProductDetails = (product) => {
        if (product) {
            const currentPath = path.pathname.includes("GetProductDetails");
            const newPath = currentPath
                ? `/ProductDetails/${formatSlug(product.product_title)}=${product.product_id}`
                : `/GetProductDetails/${formatSlug(product.product_title)}=${product.product_id}`;

            if (path.pathname !== newPath) {
                navigate(newPath);
            }
        }
    };

    const CheckWishList = (product_id) => {
        return wishList.some((item) => item.product_id === product_id);
    }

    const handleAddToWishList = (item) => {
        const newProduct = { ...item, selected_currency: currencyValue }
        dispatch(addToWishList(newProduct))
    }

    useEffect(() => {
        GetProductDetails();
        GetProducts();
    }, []);

    const getStarPercent = (rating) => {
        return (rating / 5) * 100;
    };

    return (
        <>
            <div className="col-12">
                <h2 className="section-title style-1 mb-30">Related products</h2>
            </div>
            <div className="col-12">
                <div className="row related-products">
                    {
                        productData.map((item) => {
                            return (
                                <div className="col-lg-3 col-md-4 col-12 col-sm-6 mb-4">
                                    <div key={item?.product_id} className="product-cart-wrap hover-up">
                                        <div className="product-img-action-wrap">
                                            <div className="product-img product-img-zoom">
                                                <a>
                                                    <img
                                                        onClick={() => handleProductDetails(item)}
                                                        className="default-img"
                                                        src={item?.product_image_url}
                                                        alt
                                                    />
                                                    <img
                                                        onClick={() => handleProductDetails(item)}
                                                        className="hover-img"
                                                        src={item?.product_image_url}
                                                        alt
                                                    />
                                                </a>
                                            </div>
                                            <div className="product-action-1">
                                                {
                                                    CheckWishList(data?.product_id) === true ?
                                                        <a
                                                            onClick={() => dispatch(removeWishListItem(data.product_id))}
                                                            aria-label={`Remove From Wishlist`}
                                                            className="action-btn small hover-up"
                                                            style={{ background: '#FDC040' }}
                                                        >
                                                            <i className="fi-rs-heart" />
                                                        </a>
                                                        :
                                                        <a
                                                            onClick={() => handleAddToWishList(item)}
                                                            aria-label="Add To Wishlist"
                                                            className="action-btn small hover-up" >
                                                            <i className="fi-rs-heart" />
                                                        </a>
                                                }
                                            </div>
                                            <div className="product-badges product-badges-position product-badges-mrg">
                                                <span className="hot">Hot</span>
                                            </div>
                                        </div>
                                        <div className="product-content-wrap">
                                            <h2><a>{item?.product_title}</a></h2>
                                            <div className="rating-result" style={{ width: getStarPercent(item?.average_rating) + '%' }}>
                                                <span>{item?.average_rating}</span>
                                            </div>
                                            <div className="product-price">
                                                <span> {currency} {item?.product_variant_sale_price}</span>
                                                <span className="old-price"> {currency} {item?.product_variant_mrp_price}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>

        </>
    )
}

export default ProductDetailsRelatedProducts